import { render, staticRenderFns } from "./SpecialPageColumn.vue?vue&type=template&id=1e359b60&scoped=true&"
import script from "./SpecialPageColumn.vue?vue&type=script&lang=js&"
export * from "./SpecialPageColumn.vue?vue&type=script&lang=js&"
import style0 from "./SpecialPageColumn.vue?vue&type=style&index=0&id=1e359b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e359b60",
  null
  
)

export default component.exports